import { default as Audio88QkEAoJFhMeta } from "/data/soft/jenkins/workspace/olamet-client-Pipeline-deploy/pages/Inapp/RoomApp/Audio.vue?macro=true";
import { default as CalldEYZAxm78ZMeta } from "/data/soft/jenkins/workspace/olamet-client-Pipeline-deploy/pages/Inapp/RoomApp/Call.vue?macro=true";
import { default as LiveWOZ895AIagMeta } from "/data/soft/jenkins/workspace/olamet-client-Pipeline-deploy/pages/Inapp/RoomApp/Live.vue?macro=true";
export default [
  {
    name: Audio88QkEAoJFhMeta?.name ?? "RoomApp-Audio",
    path: Audio88QkEAoJFhMeta?.path ?? "/roomApp/audio",
    meta: Audio88QkEAoJFhMeta || {},
    alias: Audio88QkEAoJFhMeta?.alias || [],
    redirect: Audio88QkEAoJFhMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/olamet-client-Pipeline-deploy/pages/Inapp/RoomApp/Audio.vue").then(m => m.default || m)
  },
  {
    name: CalldEYZAxm78ZMeta?.name ?? "RoomApp-Call",
    path: CalldEYZAxm78ZMeta?.path ?? "/roomApp/call",
    meta: CalldEYZAxm78ZMeta || {},
    alias: CalldEYZAxm78ZMeta?.alias || [],
    redirect: CalldEYZAxm78ZMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/olamet-client-Pipeline-deploy/pages/Inapp/RoomApp/Call.vue").then(m => m.default || m)
  },
  {
    name: LiveWOZ895AIagMeta?.name ?? "RoomApp-Live",
    path: LiveWOZ895AIagMeta?.path ?? "/roomApp/live",
    meta: LiveWOZ895AIagMeta || {},
    alias: LiveWOZ895AIagMeta?.alias || [],
    redirect: LiveWOZ895AIagMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/olamet-client-Pipeline-deploy/pages/Inapp/RoomApp/Live.vue").then(m => m.default || m)
  }
]